import buildUrl from 'build-url';
import { DeviceType } from 'Common/appshell_types/appshellMetaTypes';

export interface Trackers {
    iosAdjustTracker: string;
    androidAdjustTracker: string;
}

const URL = 'https://zwyf.adj.st';

// For clientside use only. E.g.: with click handlers or useEffect.
export const smartAppUrl = (host: string, trackers: Trackers, device: DeviceType) => {
    const { iosAdjustTracker, androidAdjustTracker } = trackers;
    let tracker = '';
    if (device === 'ANDROID') {
        tracker = androidAdjustTracker;
    } else if (device === 'IOS') {
        tracker = iosAdjustTracker;
    }
    const deepLinkURL = window.location.href;
    const fallbackURL = `${host}/m/app/`;
    return buildUrl(URL, {
        queryParams: {
            adjust_t: tracker,
            adjust_deeplink: deepLinkURL,
            adjust_fallback: fallbackURL,
        },
    });
};
